import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-adda',
  templateUrl: './adda.component.html',
  styleUrls: ['./adda.component.css']
})
export class AddaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
